import PropTypes from "prop-types"
import styled from "styled-components"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import CustomTooltip from "../../../../shared/CustomTooltip"
import { CZoomIn } from "../../../../shared/Icons"

const ImageWrapper = styled.span`
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  height: ${({ theme }) => theme.sizes.articleTableImageHeight}px;
  width: ${({ theme }) => theme.sizes.articleTableImageWidth}px;
  transition: opacity 0.15s ease-in-out;
  opacity: 1;
`

const StyledImage = styled.img`
  width: ${({ theme }) => theme.sizes.articleTableImageWidth}px;
  height: ${({ theme }) => theme.sizes.articleTableImageHeight}px;
  ${ImageWrapper}:hover & {
    opacity: 0.5;
    cursor: pointer;
  }
`

const ZoomInIconStyled = styled(CZoomIn)`
  width: ${({ theme }) => theme.sizes.base * 5}px;
  height: ${({ theme }) => theme.sizes.base * 5}px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  ${ImageWrapper}:hover & {
    opacity: 1;
    cursor: pointer;
  }
  color: ${({ theme }) => theme.colors.black};
`

const TableArticleImage = ({ image, text, onClick }) => {
  const { t } = useBrandedTranslation()
  const fallbackImageSrc = "/images/placeholder-image.svg"

  return (
    <CustomTooltip label={t("pdp-clickToEnlarge")}>
      {/* data-article attribute is needed to match the gallery image when clicked */}
      <ImageWrapper onClick={onClick}>
        <StyledImage src={image ?? fallbackImageSrc} alt={text} />
        <ZoomInIconStyled />
      </ImageWrapper>
    </CustomTooltip>
  )
}

export default TableArticleImage

TableArticleImage.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
}
